<mf-page title="Listas administrables">
  <mf-row>
    <mf-grid
      #grid
      actionButtonText="Nuevo valor"
      [apiEndpoint]="apiEndpoint"
      [columns]="columns"
      [menuItems]="menuItems"
      (actionButtonClick)="openNewValueList()" />
  </mf-row>
</mf-page>
